// URL slugs for the Build Your Car wizard: /quick-bid/audi/a5/all-new-a5
//
// Slugs are derived from catalog names, never stored, so a renamed model just
// changes its URL. Matching is done by comparing slugs both ways so old links
// keep working as long as the name's letters and digits do not change.

export function slugify(value) {
  return String(value || "")
    .normalize("NFKD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

// Model names usually repeat the make ("Audi A5"); the URL drops it so the
// path reads /audi/a5 rather than /audi/audi-a5.
export function modelSlug(modelName, makeName) {
  const full = slugify(modelName);
  const make = slugify(makeName);
  if (make && full.startsWith(make + "-")) return full.slice(make.length + 1);
  return full;
}

export function trimSlug(trimName) {
  return slugify(trimName);
}

// Finds the catalog entry whose slug matches the URL segment. Accepts either
// the short form (a5) or the full form (audi-a5) so hand-typed links work.
export function findBySlug(items, slug, { makeName = "", kind = "make" } = {}) {
  const wanted = slugify(slug);
  if (!wanted || !Array.isArray(items)) return null;
  return (
    items.find((item) => {
      const name = item?.name;
      if (kind === "model") {
        return modelSlug(name, makeName) === wanted || slugify(name) === wanted;
      }
      return slugify(name) === wanted;
    }) || null
  );
}

export function buildQuickBidPath(base, { make, model, trim }) {
  const parts = [];
  if (make) parts.push(slugify(make.name));
  if (make && model) parts.push(modelSlug(model.name, make.name));
  if (make && model && trim) parts.push(trimSlug(trim.name));
  return parts.length ? `${base}/${parts.join("/")}` : base;
}
